module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAASCAYAAADVCrdsAAABQklEQVRIib2WSUoEQRREn+JlvIHguFEaRTcOuBXb9kraDlspu3aKLtyKol7CWzgu5IsF2UX8zLTKNnb1MykeEfEhx/onp7TQFDAN3AH3Tf8z0QJgD+gH35tA2eRH438EYBoAG/8F0RUAIcj6qCHMgaPEnfInmpFAqAhMr2J2/htHciF2HYBbYBIoxFmZ25EciB5wLOZPwBLwDGwDl+LOICeaFISV8FDMH4BZ4CWYrQJX4m4ymhhE1ymhAcwBb+JsxXEkWlYPYt8BsAgWgHef/dsRBWKObOVC2BYciLk5MONsgwK5FvNCRVOH8NbwEZhPOFDXciSaIUdCiF4CQHUgJS+aIuxIBRHbgtwIPCW3xiA6kS2wEn60AKhkW3Mh5hZNxyAWxWEVQRsH6lpzQHYM4gz4DIb2QLGHSpMO5IAMdwRuvgBUK0hPplj1JwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sq.png
// module id = 4Ez2
// module chunks = 1